import React from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types
import { Alert, Icon, Text } from '@adc/ui-adc'
import cls from './index.scss'

const cx = classnames.bind(cls)

type AlertRole = 'success' | 'info' | ''

interface CreditBidAlertProps {
  role: AlertRole
  elmId: string
  title: string
  description: string
  descriptionElmId: string
  iconName?: string
  includeBorder?: boolean
  includeShadow?: boolean
  centered?: boolean
  style?: React.CSSProperties
  action?: React.ReactNode
}

/**
 * Standardized credit bid inline alert used across CB Reveal states.
 * Wraps the DS Alert with consistent styling: compact padding,
 * 13px description text (non-standard size per design spec), and
 * optional action slot for buttons/CTAs.
 */
const CreditBidAlert = ({
  role,
  elmId,
  title,
  description,
  descriptionElmId,
  iconName,
  includeBorder = true,
  includeShadow = false,
  centered = true,
  style,
  action,
}: CreditBidAlertProps) => {
  const titleColorClassMap: Record<AlertRole, string> = {
    success: 'credit-bid-title-success',
    info: 'credit-bid-title-info',
    '': 'credit-bid-title-gray',
  }

  const iconColorClassMap: Record<AlertRole, string> = {
    success: 'credit-bid-icon',
    info: 'credit-bid-icon',
    '': 'credit-bid-icon-gray',
  }

  const titleColorClass = titleColorClassMap[role]
  const iconColorClass = iconColorClassMap[role]

  return (
    <Alert
      role={role}
      type='inline'
      elmId={elmId}
      includeBorder={includeBorder}
      includeShadow={includeShadow}
      compact
      style={style}
      header={
        <div
          className={cx(
            'credit-bid-highlight',
            centered && 'credit-bid-centered'
          )}
        >
          <Text
            as='span'
            color=''
            className={cx('credit-bid-title', titleColorClass)}
          >
            {iconName && (
              <Icon
                name={iconName}
                iconStyle='solid'
                color='unspecified'
                className={cx(iconColorClass)}
              />
            )}
            {title}
          </Text>
          <Text
            // Non-standard 13px per design spec (no DS token exists for this size)
            style={{ fontSize: 13 }}
            color=''
            className={cx('credit-bid-helper')}
            data-elm-id={descriptionElmId}
          >
            {description}
          </Text>
          {action}
        </div>
      }
    />
  )
}

export default CreditBidAlert
